import { render } from "./PainelMedidores.vue?vue&type=template&id=810f90ca&scoped=true"
import script from "./PainelMedidores.vue?vue&type=script&lang=js"
export * from "./PainelMedidores.vue?vue&type=script&lang=js"

import "./PainelMedidores.vue?vue&type=style&index=0&id=810f90ca&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-810f90ca"]])

export default __exports__